const version=value=>typeof value==='string'&&Number.isFinite(Date.parse(value));
export function clearScanReentry(session,cert){
 const versions={...session.reentryVersions};delete versions[cert];return {...session,reentryVersions:versions};
}
// Only call for a fresh physical scan's lookup. Ordinary refreshes must never
// turn an old pending scan into proof that a later removal came back.
export function captureScanReentry(session,cert,slab){
 let next=clearScanReentry(session,cert);
 if(!slab?.reentryOnSave||!version(slab.reentryVersion))return next;
 const pending=['L','R'].some(side=>(next[side]||[]).includes(cert));
 if(!pending){
  const side=['L','R'].find(side=>(next.base?.[side]||[]).includes(cert));
  if(!side)return next;
  // A physically rescanned certificate can still occur in an old baseline.
  // Receive it as a new scan at the back, not as an untouched saved item.
  next={...next,base:{L:(next.base?.L||[]).filter(c=>c!==cert),R:(next.base?.R||[]).filter(c=>c!==cert)},[side]:[...(next[side]||[]),cert]};
 }
 return {...next,reentryVersions:{...next.reentryVersions,[cert]:slab.reentryVersion}};
}
export function scannedReentryPayload(session){
 const pending=new Set([...(session.L||[]),...(session.R||[])]);
 const reentryVersions=Object.fromEntries(Object.entries(session.reentryVersions||{}).filter(([cert,value])=>pending.has(cert)&&version(value)));
 return {reentryCerts:Object.keys(reentryVersions),reentryVersions};
}
